'use strict'

import * as types from './mutation-types'

// Actions
const actions = {
	initialiseStore (context) {
		context.commit(types.InitialiseStore)
	},

	toggleNavBar (context, payload) {
		context.commit(types.ToggleNavBar, payload)
	},

	updateCurrentUser (context, payload) {
		context.commit(types.UpdateCurrentUser, payload)
	},

	updateEntryUrl (context, payload) {
		context.commit(types.UpdateEntryUrl, payload)
	},

	updateActiveProject (context, payload) {
		context.commit(types.UpdateActiveProject, payload)
	},

	updateLastOrder (context, payload) {
		context.commit(types.UpdateLastOrder, payload)
	},

	changeCheckoutActiveTab (context, payload) {
		context.commit(types.ChangeCheckoutActiveTab, payload)
	},

	loadProductList (context, payload) {
		context.commit(types.LoadProductList, payload)
	},

	addToCart (context, product) {
		context.commit(types.AddToCart, product)
	},

	clearCart (context) {
		context.commit(types.ClearCart)
	},

	setLang (context, payload) {
		context.commit(types.SetLang, payload)
	},

	// Dialogs
	infoDialog (context, dialogObj) {
		context.commit(types.InfoDialog, dialogObj)
	}

	// async setLangNew (context, payload) {
	// 	if (payload in app.$i18n.messages) {
	// 		context.commit('setLangMutation', payload)
	// 	} else {
	// 		try {
	// 			const res = await import('Locale/${payload}.json')
	// 			app.$i18n.setLocaleMessage(payload, res.data)
	// 			context.commit('setLangMutation', payload)
	// 		}
	// 		catch (e) {
	// 			console.log(e)
	// 		}
	// 	}
	// }
}

export default actions



// WEBPACK FOOTER //
// ./src/common/store/actions.js